<template>
  <PageWrap>
    <Error404 :error="{ statusCode: 404 }" v-if="error" />
    <ProjectsPage
      :data="data"
      :breadcrumbs="[
        {
          path: '/projects',
          title: 'Проекты',
        },
        { title: data.page.title },
      ]"
      :name="`model-${data?.page?.id}`"
      v-else
    />
    <BlockFoot />
  </PageWrap>
</template>

<script setup>
const { url } = useRoute().params;
const { data, error } = await useFetch("/api/projects?url=" + url);
if (error.value) {
  const event = useRequestEvent();
  setResponseStatus(event, 404, "Page Not Found");
}
</script>
